<template>
	<v-system-bar app :color="getEvent.evenappprimarycolor" dark>
		<v-btn v-if="!getIsAnonymus" :active-class="'grey'" to="/" color="grey" @click="handleLogout">
			<span class="white--text">Sign out</span>
			<v-icon color="white">mdi-exit-to-app </v-icon>
		</v-btn>

		 <v-spacer></v-spacer>
		<span v-if="!getIsAnonymus" class="px-2">
			<v-icon color="white">mdi-account </v-icon>

			<span class="white--text font-weight-medium"> {{ getLogin.name }} {{ ` - ${getSelectedRol}` }} </span>
		</span>
		<language-selector style="width: 80px" />
		<!-- <v-btn :active-class="'primary'" to="/" class="mx-1 grey">
			<span class="mr-2 pl-2 white--text">home</span>
			<v-icon color="white">mdi-home </v-icon>
		</v-btn>

		<v-menu offset-y>
			<template v-slot:activator="{ on, attrs }">
				<v-btn class="mx-1" color="primary" v-bind="attrs" v-on="on"> usecase </v-btn>
			</template>
			<v-list dense>
				<v-list-item class="text-center" to="show/JENPDd9WrFpOncwd455OlmwLUrg0m4wA8Tb53snZsZU8Wv78om">
					<v-list-item-content>
						<v-list-item-title color="primary">SALE HASH CAMPAIGN <v-icon>mdi-ticket-confirmation-outline </v-icon></v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item class="text-center" to="show/JENPDd9WrFpOncwd455OlmwLUrg0m4wA8Tb53snZsZU8Wv78om/us/test">
					<v-list-item-content>
						<v-list-item-title color="primary"
							>SALE HASH CAMPAIGN & USER <v-icon>mdi-ticket-confirmation-outline </v-icon></v-list-item-title
						>
					</v-list-item-content>
				</v-list-item>
				<v-list-item
					class="text-center"
					to="show/JENPDd9WrFpOncwd455OlmwLUrg0m4wA8Tb53snZsZU8Wv78om/inv/P0ZWnJxKaQFrWKDXGw8GB7sySWvXY61vAGI8qzVkB6pLtSTsAj"
				>
					<v-list-item-content>
						<v-list-item-title color="primary"
							>SALE HASH CAMPAIGN & INVITADOR <v-icon>mdi-ticket-confirmation-outline </v-icon></v-list-item-title
						>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-menu> -->
	</v-system-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LanguageSelector from './LanguageSelector.vue';
import config from '../../config/config';

export default {
	components: { 'language-selector': LanguageSelector },
	data: () => ({}),

	methods: {
		...mapActions(['LOGOUT', 'DO_ANONYMOUS_LOGIN']),

		handleLogout() {
			this.LOGOUT();
		}
	},
	computed: {
		...mapGetters(['getSession', 'getLogin', 'getTicketConfigurations', 'getIsAnonymus', 'getSelectedRol', 'getEvent']),
	},
	mounted() {}
};
</script>
